import { Close, Description, Provider, Title, Viewport } from '@radix-ui/react-toast';
import { endsWith } from 'lodash';

import { Icon } from '@shared/ui/components/Icon';

import { Toast } from './Toast';
import { useToast } from './useToast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <Provider duration={3000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div>
              {title && <Title className="font-semibold">{title}</Title>}
              {description && <Description>{description}</Description>}
            </div>
            {action}
            <Close
              className="absolute right-2 top-2 rounded-md p-1 text-slate-950/50 opacity-0 transition-opacity hover:text-slate-950 focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600"
              toast-close=""
            >
              <Icon icon="check" className="h-4 w-4" />
            </Close>
          </Toast>
        );
      })}
      <Viewport className="fixed top-0 z-dropdown flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[480px]" />
    </Provider>
  );
}
